import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "availability",
})
export class AvailabilityPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any): string {
    return value || (this.translate.currentLang == "en" ? "N/A" : "لا يوجد");
  }
}
